
import { useState } from 'react';

const AssessmentSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    wechat: '',
    education: '',
    challenges: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formDataToSubmit = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        formDataToSubmit.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d428dvmmj2r470qacv10', {
        method: 'POST',
        body: new URLSearchParams(formDataToSubmit as any)
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          phone: '',
          wechat: '',
          education: '',
          challenges: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="assessment" className="py-20 bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            免费评估
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            专业顾问一对一分析，为您量身定制全球职业发展方案
          </p>
        </div>

        <div className="bg-white rounded-lg shadow-xl p-8">
          <form onSubmit={handleSubmit} data-readdy-form id="assessment-form">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                  姓名 *
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                  placeholder="请输入您的姓名"
                />
              </div>

              <div>
                <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
                  联系电话 *
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                  placeholder="请输入您的手机号码"
                />
              </div>

              <div>
                <label htmlFor="wechat" className="block text-sm font-medium text-gray-700 mb-2">
                  微信号
                </label>
                <input
                  type="text"
                  id="wechat"
                  name="wechat"
                  value={formData.wechat}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                  placeholder="请输入您的微信号"
                />
              </div>

              <div>
                <label htmlFor="education" className="block text-sm font-medium text-gray-700 mb-2">
                  当前学历 *
                </label>
                <select
                  id="education"
                  name="education"
                  value={formData.education}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm pr-8"
                >
                  <option value="">请选择您的学历</option>
                  <option value="高中">高中</option>
                  <option value="本科在读">本科在读</option>
                  <option value="本科毕业">本科毕业</option>
                  <option value="硕士在读">硕士在读</option>
                  <option value="硕士毕业">硕士毕业</option>
                  <option value="博士在读">博士在读</option>
                  <option value="博士毕业">博士毕业</option>
                  <option value="其他">其他</option>
                </select>
              </div>
            </div>

            <div className="mt-6">
              <label htmlFor="challenges" className="block text-sm font-medium text-gray-700 mb-2">
                目前面临的难题和困惑 *
              </label>
              <textarea
                id="challenges"
                name="challenges"
                value={formData.challenges}
                onChange={handleInputChange}
                required
                maxLength={500}
                rows={4}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm resize-none"
                placeholder="请详细描述您在求职、留学或移民方面遇到的困难和疑问（限500字）"
              />
              <div className="text-right text-xs text-gray-500 mt-1">
                {formData.challenges.length}/500
              </div>
            </div>

            <div className="mt-8">
              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 text-white py-4 px-8 rounded-lg font-semibold text-lg hover:from-blue-700 hover:to-indigo-700 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
              >
                {isSubmitting ? '提交中...' : '立即获取免费评估'}
              </button>
            </div>

            {submitStatus === 'success' && (
              <div className="mt-4 p-4 bg-green-50 border border-green-200 rounded-lg">
                <div className="flex items-center">
                  <i className="ri-check-circle-line text-green-600 mr-2"></i>
                  <span className="text-green-700">提交成功！我们的专业顾问将在24小时内与您联系。</span>
                </div>
              </div>
            )}

            {submitStatus === 'error' && (
              <div className="mt-4 p-4 bg-red-50 border border-red-200 rounded-lg">
                <div className="flex items-center">
                  <i className="ri-error-warning-line text-red-600 mr-2"></i>
                  <span className="text-red-700">提交失败，请稍后重试或直接联系我们。</span>
                </div>
              </div>
            )}
          </form>

          <div className="mt-8 pt-6 border-t border-gray-200">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-center">
              <div className="flex items-center justify-center space-x-2">
                <i className="ri-shield-check-line text-blue-600"></i>
                <span className="text-sm text-gray-600">信息安全保护</span>
              </div>
              <div className="flex items-center justify-center space-x-2">
                <i className="ri-time-line text-blue-600"></i>
                <span className="text-sm text-gray-600">24小时内回复</span>
              </div>
              <div className="flex items-center justify-center space-x-2">
                <i className="ri-user-star-line text-blue-600"></i>
                <span className="text-sm text-gray-600">专业顾问服务</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AssessmentSection;
